module.exports = __webpack_public_path__ + "static/media/replay_black_24dp.cc820216.svg";